import type { JobHandle, JobStatus } from '@simpleacs/shared';
import { api } from './api';

/**
 * Poll a background job to completion.
 *
 * A long chassis operation — a full inventory sync, a per-ONU resync — now
 * returns a HANDLE instead of blocking the request until the chassis answers.
 * This drives it from the tasks tray's `run()`: each poll is an instant read, so
 * the nginx 504 the blocking version hit on a slow OLT no longer applies. It
 * resolves with the job's result, or throws its failure message — which the
 * tray shows as a failed toast, exactly as a thrown request error did.
 */
export async function runJob<T>(handle: JobHandle): Promise<T> {
  for (;;) {
    const s = await api.get<JobStatus>(`/jobs/${encodeURIComponent(handle.id)}`);
    if (s.status === 'done') return s.result as T;
    if (s.status === 'failed') throw new Error(s.message ?? 'It did not finish.');
    await new Promise((resolve) => setTimeout(resolve, 1500));
  }
}
